import React, { Component } from 'react';

export class SearchInputOffers extends Component {

  render() {
    return (
      <div  className="input-field col s12">
          <input
                onChange={(e) => this.props.onOfferInputChange(e.target.value)}
                placeholder="Rechercher une offre..."
                id="first_name"
                type="text"
                className="validate" />
      </div>
    );
  }
}